import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "foam-roof-bubbles-causes-repair-phoenix";
export const Route = createFileRoute("/foam-roof-bubbles-in-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
